import { useCallback } from 'react';
import acknowledgeBeepFile from './beeps/acknowledge-beep.mp3';
import successBeepFile from './beeps/success-beep.mp3';
import errorBeepFile from './beeps/error-beep.mp3';

export default () =>
  useCallback(variant => {
    const acknowledgeBeep = new Audio(acknowledgeBeepFile);
    const successBeep = new Audio(successBeepFile);
    const errorBeep = new Audio(errorBeepFile);

    switch (variant) {
      case 'acknowledge':
        acknowledgeBeep.cloneNode(true).play();
        break;
      case 'success':
        successBeep.cloneNode(true).play();
        break;
      case 'error':
        errorBeep.cloneNode(true).play();
        break;
      default:
        acknowledgeBeep.cloneNode(true).play();
    }
  }, []);
